import React from 'react';
import { colors } from '@guryou/colors';
import { SelectCardInformation } from './SelectCardInformation';

const icon = {
  book: () => (
    <svg
      className={`w-6 h-6 text-[${colors.mandy}]`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fill-rule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
        clip-rule="evenodd"
      />
    </svg>
  ),
  read: () => (
    <svg
      className={`w-6 h-6 text-[${colors.mandy}]`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fill-rule="evenodd"
        d="M6 2a2 2 0 0 0-2 2v15a3 3 0 0 0 3 3h12a1 1 0 1 0 0-2h-2v-2h2a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2h-8v16h5v2H7a1 1 0 1 1 0-2h1V2H6Z"
        clip-rule="evenodd"
      />
    </svg>
  ),
  video: () => (
    <svg
      className={`w-6 h-6 text-[${colors.mandy}]`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fill-rule="evenodd"
        d="M19.003 3A2 2 0 0 1 21 5v2h-2V5.414L17.414 7h-2.828l2-2h-2.172l-2 2H9.586l2-2H9.414l-2 2H3V5a2 2 0 0 1 2-2h14.003ZM3 9v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9H3Zm2-2.414L6.586 5H5v1.586Zm4.553 4.52a1 1 0 0 1 1.047.094l4 3a1 1 0 0 1 0 1.6l-4 3A1 1 0 0 1 9 18v-6a1 1 0 0 1 .553-.894Z"
        clip-rule="evenodd"
      />
    </svg>
  ),
};

const SelectSection = () => {
  return (
    <section class="bg-white">
      <div class="py-8 px-4 mx-auto max-w-screen-xl sm:py-32 lg:px-6">
        <div class="max-w-screen-md mb-8 lg:mb-16">
          <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">Esperienze Wellness Personalizzate</h2>
          <p class="text-gray-500 sm:text-xl">
            Scopri il nostro servizio esclusivo per prenotare esperienze wellness su misura. Accedi facilmente a una vasta selezione di attività che
            promuovono il tuo benessere, dalla meditazione alla cura del corpo.
          </p>
        </div>
        <div class="space-y-8 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-12 md:space-y-0">
          {SelectCardInformation.map(card => (
            <div key={card.id}>
              <div class="flex justify-center items-center mb-4 w-10 h-10 rounded-full bg-primary-100 lg:h-12 lg:w-12">{icon[card.image]()}</div>
              <h3 class="mb-2 text-xl font-bold">{card.title}</h3>
              <p class="text-gray-500">{card.description1}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

  // return (
  //   <FlexRow margin={0} marginBottom={15}>
  //     <SelectCardCollection />
  //   </FlexRow>
  // );
};

export default SelectSection;
